import { SET_PRODUCT_PROPERTIES } from "./action-types";

// eslint-disable-next-line import/prefer-default-export
export function setProductProperties(properties: Array<string>) {
  return {
    type: SET_PRODUCT_PROPERTIES,
    payload: { properties },
  };
}
